export default function getSelectedBlockInfo(editorState) {
  const selectionState = editorState.getSelection();
  const startKey = selectionState.getStartKey();
  const endKey = selectionState.getEndKey();
  const blockMap = editorState.getCurrentContent().getBlockMap();
  let stopTaking = false;
  const selectedBlocks = blockMap
    .skipUntil(block => block.getKey() === startKey)
    .takeUntil(block => {
      const endBlock = stopTaking;
      if (block.getKey() === endKey) {
        stopTaking = true;
      }
      return endBlock;
    });

  return selectedBlocks
    .map(block => {
      return {
        text: block.getText(),
        characterList: block.getCharacterList(),
      };
    })
    .toArray();
}
